import React from 'react';
import PropTypes from 'prop-types';

import HorizontalSelectButtonsField from 'components/new_ui/Form/HorizontalSelectButtonsField';

export default function Field({ item, active, afterClick }) {
  return (
    <HorizontalSelectButtonsField
      name={item.id}
      label={item.attributes.title}
      wrapperClassName={`scrollable-item pb-5 ${active ? '' : 'disabled'}`}
      containerClassName="d-sm-flex select-counter-form"
      optionClassName="flex-grow-1"
      collection={[
        { value: 1, label: item.attributes.answer1 },
        { value: 2, label: item.attributes.answer2 },
      ]}
      onClick={(val, e) => {
        e.target.disabled = true;
        e.target.parentElement.classList.add('selected');

        /* eslint-disable no-restricted-syntax */
        for (const child of e.target.parentElement.parentElement.children) {
          child.classList.add('disabled');
        }
        /* eslint-enable no-restricted-syntax */

        afterClick(e.target, val);
      }}
    />
  );
}

Field.propTypes = {
  item: PropTypes.object.isRequired,
  active: PropTypes.bool.isRequired,
  afterClick: PropTypes.func.isRequired,
};
